import React, { useState, useEffect } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";


export default function DepositWithdrawal() {
    const [packages, setPackages] = useState([]);
    const [txUserId, setTxUserId] = useState("");
    const [balance, setBalance] = useState(0);
    const [actionLoading, setActionLoading] = useState(false);

    const [Tbalance, setTBalance] = useState(0);
    const [Ebalance, setEbalance] = useState(0);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingBalance, setLoadingBalance] = useState(false);

    const [actionType, setActionType] = useState(""); // transfer | withdrawal

    const [amount, setAmount] = useState("");

    const generate3LetterHash = () => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        for (let i = 0; i < 3; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };

    // Fetch packages
    const getPackages = async () => {
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "package",
                submethod: "get",
                key: process.env.REACT_APP_KEY,
            });

            if (res.data?.resCode === 200) {
                setPackages(res.data.data || []);
            }
        } catch (err) {
            console.error("Package fetch error", err);
        }
    };

    useEffect(() => {
        getPackages();
    }, []);

    const payableAmount = selectedPackage
        ? selectedPackage.amount * quantity
        : 0;

    const handlePurchase = async () => {
        console.log('txUserId', selectedPackage);

        if (!selectedPackage) {
            Swal.fire("Error", "Select a package first", "error");
            return;
        }
        // if (quantity <= 0) {
        //     Swal.fire("Error", "Enter a valid quantity", "error");
        //     return;
        // }
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "transaction",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                username: txUserId,
                amount: selectedPackage.amount,
                value: 1,
            });

            // console.log('selectedPackage.value', selectedPackage.value);

            // console.log('res.data', res.data);

            if (res.data?.resCode === 200) {
                Swal.fire("Success", "Package Purchased Successfully", "success");
                setTxUserId("");
                setSelectedPackage(null);
                setQuantity(1);
                setTBalance(0);
                setBalance(0);
            } else {
                Swal.fire("Error", res.data?.error || "Failed", "error");
            }
            setLoading(false);
        } catch (err) {
            setLoading(false);
            Swal.fire("Error", "Server Error", "error");
        }
    };

    const fetchBalance = async () => {
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoadingBalance(true);

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "ubalance",
                username: txUserId,
                key: process.env.REACT_APP_KEY,
            });
            console.log('res.data.balance', res.data.data.balance);

            if (res.data?.resCode === 200) {
                setTBalance(res.data.data.deposit);
                setEbalance(res.data.data.ecosystem_balance);
                setBalance(res.data.data.balance);
            } else {
                Swal.fire("Error", res.data?.message || "User not found", "error");
            }
        } catch {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setLoadingBalance(false);
        }
    };

    const submitAction = async () => {
        if (!amount) {
            Swal.fire("Error", "Enter amount", "error");
            return;
        }

        try {
            setActionLoading(true);

            if (actionType === "transfer") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "transfer",
                    submethod: "insert",
                    username: "1169158525",
                    amount,
                    tusername: txUserId,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setEbalance(0);
                    setBalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }

            if (actionType === "deposit") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "admin",
                    submethod: "admindeposit",
                    username: txUserId,
                    deposit: amount,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setBalance(0);
                    setEbalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }

            if (actionType === "mwithdrawal") {
                const hash = generate3LetterHash(); // e.g. ABC
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "withdrawal",
                    submethod: "manual",
                    username: txUserId,

                    amount,
                    hash,
                    key: process.env.REACT_APP_KEY,
                });

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setEbalance(0);
                    setTBalance(0);
                    setBalance(0);
                } else {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }
            if (actionType === "removedeposit") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "admin",
                    submethod: "removedepsit",
                    // username: "1169158525",
                    // username: statedata.username,
                    // authNumber: authNumber,
                    amount,
                    username: txUserId,
                    // _id: statedata.id,
                    key: process.env.REACT_APP_KEY,
                },
                    // { withCredentials: true }
                );
                // if (res.data?.resCode === 401) {
                //     toastError("Login Expired");

                //     // Call logout immediately
                //     try {
                //         await axios.post(
                //             process.env.REACT_APP_BACKEND_LINK,
                //             {
                //                 method: "logout",          // 👈 as you requested
                //                 submethod: "insert",       // 👈 as you requested
                //                 username: statedata?.username,
                //                 key: process.env.REACT_APP_KEY,
                //             },
                //             // { withCredentials: true }
                //         );
                //     } catch (error) {
                //         console.error("Logout failed:", error);
                //     } finally {
                //         // Clear frontend state
                //         localStorage.clear();

                //         // 🔥 Force full reload
                //         window.location.replace("/");
                //     }
                // }
                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setEbalance(0);
                    setBalance(0);
                }
                if (res.data?.resCode === 400) {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }
            if (actionType === "removecosystem") {
                const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                    method: "admin",
                    submethod: "removecosystem",
                    // username: "1169158525",
                    // username: statedata.username,
                    // authNumber: authNumber,
                    amount,
                    username: txUserId,
                    // _id: statedata.id,
                    key: process.env.REACT_APP_KEY,
                },
                    // { withCredentials: true }
                );

                if (res.data?.resCode === 200) {
                    Swal.fire("Success", res.data.msg, "success");
                    fetchBalance();
                    setAmount("");
                    setTxUserId("");
                    setTBalance(0);
                    setEbalance(0);
                    setBalance(0);
                }
                if (res.data?.resCode === 400) {
                    Swal.fire("Error", res.data?.error, "error");
                }
            }
        } catch (err) {
            Swal.fire("Error", "Action failed", "error");
        } finally {
            setActionLoading(false);
        }
    };

    useEffect(() => {
        if (!txUserId || txUserId.trim() === "") {
            setBalance(0);
            setEbalance(0);
            setTBalance(0);
        }
    }, [txUserId]);


    const actionOptions = [
        { id: "transfer", label: "Transfer", icon: "ri-exchange-line" },
        { id: "deposit", label: "Deposit", icon: "ri-wallet-3-line" },
        { id: "stake", label: "Staking", icon: "ri-stack-line" },
        { id: "mwithdrawal", label: "Manual Withdrawal", icon: "ri-money-dollar-circle-line" },
        { id: "removedeposit", label: "Remove Deposit", icon: "ri-indeterminate-circle-line", danger: true },
        { id: "removecosystem", label: "Remove Ecosystem", icon: "ri-delete-bin-line", danger: true },
    ];

    const confirmLabels = {
        transfer: { loading: "Transferring...", done: "Confirm Transfer" },
        deposit: { loading: "Processing...", done: "Confirm Deposit" },
        mwithdrawal: { loading: "Processing...", done: "Confirm Withdrawal" },
        removedeposit: { loading: "Processing...", done: "Confirm Remove Deposit" },
        removecosystem: { loading: "Processing...", done: "Confirm Remove Ecosystem Balance" },
    };

    const renderActionForm = (type) => {
        const labels = confirmLabels[type];
        if (!labels) return null;

        return (
            <div className="glass-card form-card animate-slide-up">
                <div className="form-header">
                    <h4>{actionOptions.find((a) => a.id === type)?.label}</h4>
                    {txUserId && <span className="badge">User: {txUserId}</span>}
                </div>
                <div className="form-fields">
                    <div className="field-group">
                        <label>Username</label>
                        <input type="text" value={txUserId} disabled placeholder="Enter User ID above" />
                    </div>
                    <div className="field-group">
                        <label>Amount</label>
                        <input
                            type="number"
                            placeholder="Enter amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>
                </div>
                <button
                    className={`primary-btn full ${actionOptions.find((a) => a.id === type)?.danger ? "danger" : ""}`}
                    onClick={submitAction}
                    disabled={actionLoading}
                >
                    {actionLoading ? (
                        <>
                            <i className="ri-loader-4-line spin" />
                            {labels.loading}
                        </>
                    ) : (
                        labels.done
                    )}
                </button>
            </div>
        );
    };

    return (
        <>
            <Header />
            <Sidebar />

            <div className="admin-ops-page">
                <h2 className="buy-title">Admin Operations</h2>

                <div className="glass-card search-card">
                    <div className="input-field-wrapper">
                        <i className="ri-user-search-line prefix-icon" />
                        <input
                            type="text"
                            placeholder="Enter User ID"
                            value={txUserId}
                            onChange={(e) => setTxUserId(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && !loadingBalance && fetchBalance()}
                        />
                        <button
                            type="button"
                            className="search-btn"
                            onClick={fetchBalance}
                            disabled={loadingBalance}
                        >
                            {loadingBalance ? (
                                <>
                                    <i className="ri-loader-4-line spin" />
                                    Checking...
                                </>
                            ) : (
                                "Show Balance"
                            )}
                        </button>
                    </div>
                </div>

                {balance !== null && Tbalance !== null && Ebalance !== null && (
                    <div className="balance-grid">
                        <div className="balance-card">
                            <i className="ri-wallet-line balance-icon" />
                            <span className="balance-label">Withdrawal Balance</span>
                            <strong className="balance-value">${Number(balance).toFixed(2)}</strong>
                        </div>
                        <div className="balance-card">
                            <i className="ri-stack-line balance-icon" />
                            <span className="balance-label">Staking Balance</span>
                            <strong className="balance-value">${Number(Tbalance).toFixed(2)}</strong>
                        </div>
                        <div className="balance-card">
                            <i className="ri-plant-line balance-icon" />
                            <span className="balance-label">Ecosystem Balance</span>
                            <strong className="balance-value">${Number(Ebalance).toFixed(2)}</strong>
                        </div>
                    </div>
                )}

                <div className="action-section">
                    <h3 className="section-label">Select Operation</h3>
                    <div className="action-grid">
                        {actionOptions.map((action) => (
                            <button
                                key={action.id}
                                type="button"
                                className={`action-chip ${actionType === action.id ? "active" : ""} ${action.danger ? "danger" : ""}`}
                                onClick={() => setActionType(action.id)}
                            >
                                <i className={action.icon} />
                                <span>{action.label}</span>
                            </button>
                        ))}
                    </div>

                    {actionType === "stake" && (
                        <div className="glass-card form-card animate-slide-up stake-section">
                            <div className="form-header">
                                <h4>Buy Package</h4>
                                {txUserId && <span className="badge">User: {txUserId}</span>}
                            </div>

                            <div className="package-grid">
                                {packages.map((pkg) => (
                                    <div
                                        key={pkg.value}
                                        className={`package-card ${selectedPackage?.value === pkg.value ? "active" : ""}`}
                                        onClick={() => setSelectedPackage(pkg)}
                                    >
                                        <h4>{pkg.p_name}</h4>
                                        <span className="price">${pkg.amount}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="bottom-section">
                                <div className="quantity-group">
                                    <label>Quantity</label>
                                    <input type="number" min="1" value={quantity} disabled readOnly />
                                </div>
                                <div className="payable-amount">
                                    Payable Amount
                                    <strong>${payableAmount}</strong>
                                </div>
                            </div>

                            <button className="primary-btn full" onClick={handlePurchase} disabled={loading}>
                                {loading ? (
                                    <>
                                        <i className="ri-loader-4-line spin" />
                                        Please wait 3-5 minutes...
                                    </>
                                ) : (
                                    "Confirm Purchase"
                                )}
                            </button>
                        </div>
                    )}

                    {["transfer", "deposit", "mwithdrawal", "removedeposit", "removecosystem"].includes(actionType) &&
                        renderActionForm(actionType)}
                </div>
            </div>

            <style>
                {`
                .admin-ops-page {
                    max-width: 640px;
                    margin: 70px auto 24px;
                    padding: 12px 16px;
                    font-family: 'Inter', system-ui, -apple-system, sans-serif;
                }

                .buy-title {
                    font-size: 20px;
                    font-weight: 800;
                    background: linear-gradient(135deg, #405189, #1a2a6c);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    margin-bottom: 16px;
                    text-align: center;
                    letter-spacing: -0.5px;
                }

                .glass-card {
                    background: rgba(255, 255, 255, 0.98);
                    backdrop-filter: blur(12px);
                    border: 1px solid rgba(226, 232, 240, 0.8);
                    border-radius: 14px;
                    padding: 14px 16px;
                    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.03), 0 3px 10px rgba(64, 81, 137, 0.05);
                }

                .search-card { margin-bottom: 14px; }

                .input-field-wrapper {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    background: #f8fafc;
                    border: 1px solid #f1f5f9;
                    border-radius: 10px;
                    padding: 4px 4px 4px 10px;
                    transition: all 0.3s ease;
                }

                .input-field-wrapper:focus-within {
                    border-color: #405189;
                    background: #fff;
                    box-shadow: 0 4px 12px rgba(64, 81, 137, 0.08);
                }

                .input-field-wrapper input {
                    flex: 1;
                    min-width: 0;
                    border: none;
                    background: transparent;
                    padding: 8px 6px;
                    font-size: 13px;
                    color: #1e293b;
                    font-weight: 500;
                    outline: none;
                }

                .prefix-icon {
                    font-size: 16px;
                    color: #94a3b8;
                    flex-shrink: 0;
                }

                .search-btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    background: #405189;
                    color: white;
                    border: none;
                    padding: 8px 14px;
                    border-radius: 8px;
                    font-weight: 600;
                    font-size: 12px;
                    cursor: pointer;
                    white-space: nowrap;
                    flex-shrink: 0;
                    transition: all 0.3s ease;
                }

                .search-btn:hover:not(:disabled) {
                    background: #2b3a67;
                    transform: translateY(-1px);
                }

                .search-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .balance-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 8px;
                    margin-bottom: 14px;
                }

                .balance-card {
                    background: #fff;
                    border: 1px solid #f1f5f9;
                    border-radius: 10px;
                    padding: 10px 8px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 2px;
                    transition: all 0.3s ease;
                }

                .balance-card:hover {
                    border-color: #e2e8f0;
                    box-shadow: 0 4px 10px rgba(64, 81, 137, 0.06);
                }

                .balance-icon {
                    font-size: 18px;
                    color: #405189;
                }

                .balance-label {
                    font-size: 10px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                }

                .balance-value {
                    font-size: 15px;
                    font-weight: 800;
                    color: #1e293b;
                }

                .section-label {
                    font-size: 11px;
                    font-weight: 700;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    text-align: center;
                    margin: 0 0 8px;
                }

                .action-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 8px;
                    margin-bottom: 14px;
                }

                .action-chip {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 4px;
                    padding: 8px 6px;
                    border-radius: 10px;
                    border: 1px solid #f1f5f9;
                    background: #fff;
                    color: #475569;
                    font-size: 11px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    text-align: center;
                    min-height: 56px;
                }

                .action-chip i {
                    font-size: 16px;
                    color: #94a3b8;
                    transition: color 0.3s ease;
                }

                .action-chip:hover {
                    border-color: #e2e8f0;
                    transform: translateY(-2px);
                }

                .action-chip.active {
                    border-color: #405189;
                    background: rgba(64, 81, 137, 0.05);
                    color: #405189;
                    box-shadow: 0 8px 20px rgba(64, 81, 137, 0.08);
                }

                .action-chip.active i { color: #405189; }

                .action-chip.danger.active {
                    border-color: #dc2626;
                    background: rgba(220, 38, 38, 0.05);
                    color: #dc2626;
                }

                .action-chip.danger.active i { color: #dc2626; }

                .form-card { margin-top: 4px; }

                .form-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 6px;
                    margin-bottom: 12px;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #f8fafc;
                }

                .form-header h4 {
                    margin: 0;
                    color: #1e293b;
                    font-size: 14px;
                    font-weight: 700;
                }

                .badge {
                    background: #f0f4ff;
                    color: #405189;
                    padding: 3px 8px;
                    border-radius: 12px;
                    font-size: 10px;
                    font-weight: 600;
                    border: 1px solid rgba(64, 81, 137, 0.1);
                }

                .form-fields {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    margin-bottom: 12px;
                }

                .field-group label {
                    display: block;
                    font-weight: 600;
                    color: #334155;
                    margin-bottom: 4px;
                    font-size: 12px;
                }

                .field-group input {
                    width: 100%;
                    padding: 8px 10px;
                    border-radius: 8px;
                    border: 1px solid #f1f5f9;
                    background: #f8fafc;
                    font-size: 13px;
                    color: #1e293b;
                    font-weight: 500;
                    outline: none;
                    transition: all 0.3s ease;
                    box-sizing: border-box;
                }

                .field-group input:focus {
                    border-color: #405189;
                    background: #fff;
                }

                .field-group input:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                }

                .primary-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    background: linear-gradient(135deg, #405189, #2b3a67);
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 10px;
                    font-weight: 600;
                    font-size: 13px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .primary-btn.full { width: 100%; }

                .primary-btn:hover:not(:disabled) {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 24px rgba(64, 81, 137, 0.25);
                }

                .primary-btn:disabled {
                    opacity: 0.7;
                    cursor: not-allowed;
                    transform: none;
                    box-shadow: none;
                }

                .primary-btn.danger {
                    background: linear-gradient(135deg, #dc2626, #b91c1c);
                }

                .primary-btn.danger:hover:not(:disabled) {
                    box-shadow: 0 12px 24px rgba(220, 38, 38, 0.25);
                }

                .package-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
                    gap: 8px;
                    margin-bottom: 12px;
                }

                .package-card {
                    padding: 10px 8px;
                    border-radius: 10px;
                    border: 1px solid #f1f5f9;
                    background: #f8fafc;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    text-align: center;
                }

                .package-card h4 {
                    margin: 0 0 4px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #334155;
                }

                .package-card .price {
                    font-size: 15px;
                    font-weight: 800;
                    color: #405189;
                }

                .package-card:hover {
                    border-color: #e2e8f0;
                }

                .package-card.active {
                    border-color: #405189;
                    background: rgba(64, 81, 137, 0.05);
                    box-shadow: 0 8px 20px rgba(64, 81, 137, 0.08);
                }

                .bottom-section {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 10px;
                    margin-bottom: 12px;
                    padding: 10px 12px;
                    background: #f8fafc;
                    border-radius: 10px;
                }

                .quantity-group {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                }

                .quantity-group label {
                    font-weight: 600;
                    color: #334155;
                    font-size: 12px;
                }

                .quantity-group input {
                    width: 50px;
                    padding: 4px;
                    border-radius: 6px;
                    border: 1px solid #e2e8f0;
                    text-align: center;
                    font-weight: 600;
                    font-size: 13px;
                }

                .payable-amount {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    text-align: right;
                }

                .payable-amount strong {
                    display: block;
                    font-size: 16px;
                    color: #405189;
                    margin-top: 2px;
                }

                .animate-slide-up {
                    animation: slideUp 0.4s cubic-bezier(0.23, 1, 0.32, 1) forwards;
                }

                @keyframes slideUp {
                    from { transform: translateY(20px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }

                .spin { animation: spin 1s linear infinite; }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                @media (max-width: 768px) {
                    .admin-ops-page {
                        margin-top: 65px;
                        padding: 10px 12px;
                    }

                    .balance-grid {
                        grid-template-columns: repeat(3, 1fr);
                    }

                    .action-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .input-field-wrapper {
                        flex-wrap: wrap;
                        padding: 8px;
                    }

                    .input-field-wrapper input {
                        width: 100%;
                        flex: 1 1 100%;
                    }

                    .search-btn {
                        width: 100%;
                        justify-content: center;
                    }
                }

                @media (max-width: 480px) {
                    .balance-grid {
                        grid-template-columns: 1fr;
                    }

                    .action-grid {
                        grid-template-columns: repeat(2, 1fr);
                    }

                    .action-chip {
                        flex-direction: row;
                        justify-content: flex-start;
                        min-height: auto;
                        padding: 8px 10px;
                    }

                    .bottom-section {
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .payable-amount {
                        text-align: left;
                    }
                }
                `}
            </style>
            <Footer />
        </>
    );
}
